<template>
  <el-table-column
    prop="start_date"
    sortable="custom"
    label="Leltározás kezdete"
    show-overflow-tooltip
    min-width="180"
  >
    <template slot-scope="scope">
      {{ scope.row.start_date | dateTime }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'start_date',
  };
</script>
